import {
  Grid,
  Button,
  Typography,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import CustomDialogModal from './Custom';

const MaterialDialog = ({
  isOpen,
  handleIsOpen,
  handleConfirm,
  titleText = '',
  actionsButton = true,
  children,
  yesNo = false,
  maxWidth = 'sm',
}) => {
  const confirmDialog = () => {
    handleConfirm?.();
    handleIsOpen(false);
  };

  const closeDialog = () => handleIsOpen(false);

  return (
    <CustomDialogModal
      open={isOpen}
      onClose={closeDialog}
      sxDialog={{ maxWidth }}
    >
      {/* Header */}
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {titleText}
        </Typography>
        <IconButton onClick={closeDialog}>
          <CloseIcon />
        </IconButton>
      </Grid>

      {/* Contenido */}
      <Grid sx={{ p: 2 }}>{children}</Grid>

      {/* Acciones */}
      {actionsButton && (
        <DialogActions sx={{ justifyContent: 'center', gap: 1 }}>
          <Button
            onClick={confirmDialog}
            variant="contained"
            sx={{ backgroundColor: yesNo ? 'green' : undefined }}
          >
            {yesNo ? 'Si' : 'Aceptar'}
          </Button>
          <Button
            onClick={closeDialog}
            variant="contained"
            sx={{ backgroundColor: '#EB5A46', color: 'white' }}
          >
            {yesNo ? 'No' : 'Cancelar'}
          </Button>
        </DialogActions>
      )}
    </CustomDialogModal>
  );
};

export default MaterialDialog;
